import definition from './categories.service';

/**
 * CategoriesApi settings
 * @type {{name: string, definition: CategoriesApi}}
 */
export default {
    name: 'CategoriesApi',
    definition
};



// WEBPACK FOOTER //
// ./app/services/api/categories/index.js